import { IndirectTaxTransactionHelper } from '../helpers';
import {
  TIndirectTaxLineItemTaxLogic,
  TIndirectTaxLineItemTaxLogicHandlers,
} from '../types';
import { IndirectTaxLineItemTaxLogicCheck } from './IndirectTaxLineItemTaxLogicCheck';

interface IndirectTaxLineItemTaxLogicProps
  extends TIndirectTaxLineItemTaxLogicHandlers {
  taxLogic?: TIndirectTaxLineItemTaxLogic;
}

const IndirectTaxLineItemTaxLogic = ({
  taxLogic,
  onViewRegistration,
  onViewCustomer,
  onViewProduct,
}: IndirectTaxLineItemTaxLogicProps) => {
  if (!taxLogic) {
    return (
      <p className="txt-small-regular text-text-tertiary px-3xl pb-3xl">
        Tax logic isn't available for this line item yet.
      </p>
    );
  }

  const rows = IndirectTaxTransactionHelper.buildLineItemTaxLogicRows(
    taxLogic,
    {
      onViewRegistration,
      onViewCustomer,
      onViewProduct,
    }
  );

  return (
    <div className="flex flex-col px-3xl pb-3xl">
      {rows.map((row, index) => (
        <IndirectTaxLineItemTaxLogicCheck
          key={row.question}
          row={row}
          isLast={index === rows.length - 1}
        />
      ))}
    </div>
  );
};

export { IndirectTaxLineItemTaxLogic };
